export default __webpack_public_path__ + "static/media/marketing.e4fed0a5.svg";